
import Vue from "vue";
import { adminResetUserPassword } from "@/api";
import { logger } from "@/utils/logger";

interface UserInfo {
  id: number;
  email: string;
  hygienistId?: number;
  dentistId?: number;
}

interface ResetResult {
  success: boolean;
  message: string;
  temporaryPassword: string;
  emailSent: boolean;
  userEmail: string;
}

export default Vue.extend({
  name: "PasswordResetDialog",
  data() {
    return {
      dialog: false,
      confirmed: false,
      loading: false,
      errorMessage: "",
      successResult: null as ResetResult | null,
      userInfo: {
        id: 0,
        email: "",
        hygienistId: undefined,
        dentistId: undefined
      } as UserInfo,
      manualPassword: "",
      showPassword: false
    };
  },
  methods: {
    openDialog(userInfo: UserInfo) {
      this.userInfo = userInfo;
      this.dialog = true;
      this.confirmed = false;
      this.loading = false;
      this.errorMessage = "";
      this.successResult = null;
      this.manualPassword = "";
      this.showPassword = false;
    },

    closeDialog() {
      this.dialog = false;
      this.userInfo = {
        id: 0,
        email: "",
        hygienistId: undefined,
        dentistId: undefined
      };
      this.confirmed = false;
      this.loading = false;
      this.errorMessage = "";
      this.successResult = null;
      this.manualPassword = "";
      this.showPassword = false;
    },

    async resetPassword() {
      if (!this.confirmed || !this.userInfo.id) {
        return;
      }

      this.loading = true;
      this.errorMessage = "";

      try {
        logger.debug("PasswordResetDialog: Resetting password for user", {
          userId: this.userInfo.id
        });

        const result = await adminResetUserPassword(
          this.userInfo.id,
          this.manualPassword || undefined
        );

        logger.info("PasswordResetDialog: Password reset successful", {
          userId: this.userInfo.id
        });

        this.successResult = result;

        // Emit success event to parent component
        this.$emit("password-reset-success", {
          userId: this.userInfo.id,
          result: result
        });
      } catch (error) {
        logger.error(
          "PasswordResetDialog: Password reset failed",
          error as Error,
          {
            userId: this.userInfo.id
          }
        );
        this.errorMessage =
          error instanceof Error
            ? error.message
            : "Password reset failed. Please try again.";
      } finally {
        this.loading = false;
      }
    },

    getUserType(userInfo: UserInfo): string {
      if (userInfo.hygienistId) {
        return "Dental Professional";
      } else if (userInfo.dentistId) {
        return "Dental Office";
      }
      return "Unknown";
    }
  }
});
